import {connect} from 'react-redux';
import {DesignChapter} from '@learningblocks/storybook-components';

import {getIsModalOpen} from './TechniqueViewComplete.selector';
import {setChapter, viewFourComplete} from '@learningblocks/exp-redux';

function mapStateToProps(state, ownProps) {
  return {
    isOpen: getIsModalOpen(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onClickNext: (params) => {
      dispatch(setChapter(params));
      dispatch(viewFourComplete());
    },
  };
}

export const TechniqueViewComplete = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.TechniqueViewComplete);
